import React, {useContext, useEffect, useState} from 'react';
import style from "../Types/types.module.css";
import Table from "../../Table";
import TableModal from "../../Users/TableModal";
import pen from "../../../../assets/tables/pen.svg";
import trash from "../../../../assets/tables/delete.svg";
import AddAccess from "./AccessModal";
import axios from "../../../../API/api";
import {Store} from "../../../../Store";
import penDark from "../../../../assets/tables/penDark.svg";
import trashDark from "../../../../assets/tables/trashDark.svg";
import {useTranslation} from "react-i18next";

export default function Role() {
   const {state, dispatch} = useContext(Store);
   const [mainData, setMainData] = useState([]);
   const [totalCount, setTotalCount] = useState([]);
   const {t} = useTranslation()
   useEffect(() => {
      axios.get(`/api/v1/permissions?page=${state.page}&perPage=${state.perPage}`, {headers: {Authorization: `Bearer ${state.token}`}})
         .then((res) => {
            setMainData(res.data.data)
            setTotalCount(res.data.totalCount)

         })
         .catch((err) => {
            console.log(err)
            if(err.response ? err.response.status === 401: ''){
               localStorage.removeItem('id_token');
               return dispatch({type: 'SET_TOKEN', payload: ''})
            }
         })
   }, [state.updated, state.page, state.perPage, dispatch, state.token])

   const columns = React.useMemo(
      () => [
         {
            Header: '№',
            accessor: 'id',
            Width: 10,
            Cell: ({row}) => {
               return state.page*state.perPage +row.index+1
            }
         },
         {
            Header: 'Code',
            accessor: 'code',
            sortBy: true
         },
         {
            Header: 'Name',
            accessor: 'name',
            sortBy: true
         },
         {
            Header: 'Name Uz',
            accessor: "nameUz",
            sortBy: true
         },
         {
            Header: 'Name Ru',
            accessor: 'nameRu',
            sortBy: true
         },
         {
            Header: 'Name En',
            accessor: 'nameEn',
            sortBy: true
         },
         {
            Header: 'Created Date',
            accessor: 'createdDate',
            sortBy: true
         },
         {
            Header: t('action'),
            accessor: 'action',
            Width: 100,
            Cell: (row) => {
               return <div className={style.TakeAction}>
                  <AddAccess img={state.mode === 'dark' ? pen : penDark} data={row.row.original}/>
                  <TableModal img={state.mode === 'dark' ? trash : trashDark} user={'delete'} title={t('Remove permission')} url={'/api/v1/permissions'}
                              deleteId={row.row.values.id}/>
               </div>
            }
         },
      ],
      [t, state.mode, state.page, state.perPage],
   )

   const data = React.useMemo(
      () => mainData,
      [mainData]
   )

   return (
      <div className={style[state.mode]}>
         <div className={style.top}>
            <p>{t('Permission')}</p>
            <AddAccess/>
         </div>
         <div className={style.roleTable}>
            <Table data={data} columns={columns} totalCount={totalCount}/>
         </div>
      </div>
   )
}